import React, { useEffect, useState } from 'react';

/**
 *
 * @param initialValue
 * @param timeout
 * @returns [debouncedValue, value, setValue]
 */
export const useDebounce = <T,>(
  initialValue: T,
  timeout = 500
): [T, T, React.Dispatch<React.SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(initialValue);
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, timeout);

    return () => {
      clearTimeout(timer);
    };
  }, [value, timeout]);

  return [debouncedValue, value, setValue];
};
